import script from "./couponSend.vue?vue&type=script&setup=true&lang=js"
export * from "./couponSend.vue?vue&type=script&setup=true&lang=js"

import "./couponSend.vue?vue&type=style&index=0&id=7abb7a10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7abb7a10"]])

export default __exports__